<template>
    <div class="home">
        <div class="header">
        <HeaderBar></HeaderBar>
        <HeaderMenu :cartQty=cartQty :productSalesPrice=productSalesPrice @childEvent="popupCheckout"></HeaderMenu>
        <AppLoading v-if="loading" />
        </div>
        <div class="product bg-background" >
      
          <div  :class="{'fixed-div': isFixed}" class="fixed-content d-flex justify-space-between" >
          <div>Total Products : ₹.{{ productRate }}</div>
          <div>Discount Total : ₹.{{ productOfferPrice }}</div>
          <div>Overall Total : ₹.{{ productSalesPrice }}</div>
          </div>
          <div class="text-right">
            <v-btn color="primary" class="mr-2 mb-2 mt-2" outlined  @click="priceListOpen">Download Price List</v-btn>
          </div>
            <div v-for="(category, i) in products" :key="i">
              <div class="bg-primary">
                <h3 class="text-center mb-5 pa-3">
                {{ category.categoryname }}
              </h3>
              </div>
              
              <v-container fluid>
              <v-row justify="space-around" id="container" ref="container">
                <v-col cols="12" sm="6" md="6" v-for="(product, i) in category.products"
                :key="i" >
                  <v-card class="mx-auto pa-2"  variant="tonal" color="primary">
    
                <!--web Screen-->
              <div class="d-none d-sm-none d-md-flex d-lg-flex d-xl-flex justify-space-between">
              <div class="text-center">
                <div class="bg-info rounded-e-lg mx-auto ml-n3 mt-n3 pa-2" style="height: 35px; width: 35px;font-size: 14px;">
                  {{ product.sno }}</div>
              </div> 
                <!-- <v-badge color="error" :content="p" inline class="mr-n10 ml-n3 mt-n2"></v-badge> -->
                  <div class="mr-2 d-block" >
                    <v-avatar rounded="0" size="180" @click="imageDialogOpen(product.image)" class="align-center align-self-center pa-1 mt-1 product-img">
                    <v-img :src="product.image" height="150" contain ></v-img>
                    </v-avatar>

                    <v-btn density="default" icon="mdi-youtube" color="red" size="50" @click="youtubeOpen(product.youtube_url)"
                    v-if="product.youtube_url"></v-btn>
                  </div>
                  <div class="mr-2 mt-5">
                      <h3 class="text-wrap text-primary standard-font">{{ product.name }}</h3>
                      <h3 class="text-wrap text-info standard-font">{{ product.tamil_name }}</h3>
                  </div>
    
                  <div class="mr-3 ml-1 mt-5">
                      <h3 class="text-wrap text-primary medium-font">{{ product.content }}</h3>
                  </div>
    
                  <div class="mt-5">
                      <h3 class="text-wrap text-info standard-font text-decoration-line-through">Rs.{{ product.rate }}</h3>
                      <h3 class="text-wrap text-primary standard-font"> Rs.{{ product.salesprice }}</h3>
                  </div>
    
                  <div class="d-none d-sm-block d-md-block d-lg-block mt-5">
                    <h3 class="text-wrap text-info standard-font text-center"> Rs.{{ product.totalSalesPrice }}</h3>
                    <div>
                                <v-btn size="24" variant="flat" color="primary" icon  @click="decrement(product)">
                                    <v-icon color="white" size="14">mdi-minus</v-icon>
                                </v-btn>
                                <span class="text-black ml-2 mr-2">
                                    <input type="number" v-model="product.qty" class="product-web-textbox"  @change="productQtyUpdate(product)">
                                </span>
                                <v-btn size="24" variant="flat" color="primary" icon  @click="increment(product)">
                                    <v-icon color="white" size="14">mdi-plus</v-icon>
                                </v-btn>
                      </div>
    
                  </div>
    
    
                </div>
                <!--web Screen-->
    
              <!--mobile Screen-->
              <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none justify-space-between">
                <div class="d-flex justify-space-between">
                  <div class="text-center">
                    <div class="bg-info rounded-e-lg mx-auto ml-n3 mt-n3 pa-2" style="height: 35px; width: 35px; font-size: 14px;">
                      {{ product.sno }}
                    </div>
                  </div>
                  <!-- <v-badge color="error" :content="p" inline class="mr-n10 ml-n3 mt-n2 "></v-badge> -->
                  <div class="mr-2">
                      <v-avatar size="150" tile class="align-center align-self-center pa-1 mt-1 product-img" @click="imageDialogOpen(product.image)">
                        <v-img :src="product.image"  height="120"></v-img>
                      </v-avatar>                  
                  </div>
                  <div class="mr-2 mt-5">
                      <h3 class="text-wrap text-primary standard-font">{{ product.name }}</h3>
                      <h3 class="text-wrap text-info standard-font"> {{ product.tamil_name }}</h3>
                  </div>
    
                  <div class="mr-3 ml-1 mt-5">
                      <h3 class="text-wrap text-primary medium-font">{{ product.content }}</h3>
                  </div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>
                    <v-btn density="default" icon="mdi-youtube" color="red" size="40" @click="youtubeOpen(product.youtube_url)"
                    v-if="product.youtube_url"></v-btn>
                  </div>
                  <div>
                    <h3 class="text-wrap text-info standard-font text-decoration-line-through">Rs.{{ product.rate }}</h3>
                    <h3 class="text-wrap text-primary standard-font"> Rs.{{ product.salesprice }}</h3>
                  </div>  
                  <div class="d-block d-sm-none d-md-none d-lg-none">
                        <div>
                              <v-btn size="20" variant="flat" color="primary" icon @click="decrement(product)">
                                  <v-icon color="white" size="15">mdi-minus</v-icon>
                              </v-btn>
                              <span class="text-black mobile-qty">
                                  <!-- {{ product.qty }} -->
                                  <input class="product-mobile-textbox"  v-model="product.qty" @change="productQtyUpdate(product)">
                              </span>
                              <v-btn size="20" variant="flat" color="primary" icon  class="product-mobile-buttonplus" @click="increment(product)">
                                  <v-icon color="white" size="15">mdi-plus</v-icon>
                              </v-btn>
                        </div>
                  </div>
                  <div>
                    <h3 class="text-wrap text-info standard-font text-center"> Rs.{{ product.totalSalesPrice }}</h3>
                  </div>
                </div>
                </div>
                <!--mobile Screen-->
              </v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
        <div class="footer">
        <FooterSection  :cartQty=cartQty @childEvent="popupCheckout"></FooterSection>
        </div>
      </div>
    
      <v-dialog v-model="imageDialog" width="500">
          <v-card>
            <v-toolbar>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="imageDialog = false" color="primary">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-img :src="clickedImage"></v-img>
          </v-card>
        </v-dialog>
    
        <v-dialog v-model="errorDialog" max-width="590">
          <v-card>
            <v-card-title class="text-h5"> </v-card-title>
            <v-card-text>
              <v-alert text prominent type="error" v-if="errorResponse">
                <div v-for="(error, i) in cartError.response" :key="i">
                  <h3 v-html="error"></h3>
                </div>
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="errorDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    
    
        <v-dialog
          v-model="checkoutDialog" persistent  transition="dialog-top-transition"  width="900"
        >
          <v-card>
            <v-card-title class="text-h5 red darken-2 white--text">
              Checkout
            </v-card-title>
    
            <v-card-text class="mt-5">
              <v-list three-line>
       
                  <div
                    v-for="(category, i) in products"
                    :key="i"
                    class="product-cart-div"
                  >
                    <div
                      v-for="(product, k) in category.products"
                      :key="k"
                      class="product-cart-div"
                    >
                     
    
                      <v-card class="mx-auto pa-2"  variant="tonal" color="primary" v-if="product.qty > 0">
    
    <!--web Screen-->
    <div class="d-none d-sm-none d-md-flex d-lg-flex d-xl-flex justify-space-between">
    <div class="text-center">
    <div class="bg-info rounded-e-lg mx-auto ml-n3 mt-n3 pa-2" style="height: 35px; width: 35px;font-size: 14px;">
      {{ product.sno }}</div>
    </div> 
    
     
      <div class="mr-2 mt-5">
          <h3 class="text-wrap text-primary standard-font">{{ product.name }}</h3>
          <h3 class="text-wrap text-info standard-font">{{ product.tamil_name }}</h3>
      </div>
    
      <div class="mr-3 ml-1 mt-5">
          <h3 class="text-wrap text-primary medium-font">{{ product.content }}</h3>
      </div>
    
      <div class="mt-5">
          <h3 class="text-wrap text-info standard-font text-decoration-line-through">Rs.{{ product.rate }}</h3>
          <h3 class="text-wrap text-primary standard-font"> Rs.{{ product.salesprice }}</h3>
      </div>
    
      <div class="d-none d-sm-block d-md-block d-lg-block mt-5">
        <h3 class="text-wrap text-info standard-font text-center"> Rs.{{ product.totalSalesPrice }}</h3>
        <div>
                    <v-btn size="24" variant="flat" color="primary" icon  @click="decrement(product)">
                        <v-icon color="white" size="14">mdi-minus</v-icon>
                    </v-btn>
                    <span class="text-black ml-2 mr-2">
                        <input type="number" v-model="product.qty" class="product-web-textbox"  @change="productQtyUpdate(product)">
                    </span>
                    <v-btn size="24" variant="flat" color="primary" icon  @click="increment(product)">
                        <v-icon color="white" size="14">mdi-plus</v-icon>
                    </v-btn>
          </div>
    
      </div>
    
 
    </div>
    <!--web Screen-->
    
    <!--mobile Screen-->
    <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none justify-space-between">
    <div class="d-flex justify-space-between">
      <div class="text-center">
        <div class="bg-info rounded-e-lg mx-auto ml-n3 mt-n3 pa-2" style="height: 35px; width: 35px; font-size: 14px;">
          {{ product.sno }}
        </div>
      </div>
      <!-- <v-badge color="error" :content="p" inline class="mr-n10 ml-n3 mt-n2 "></v-badge> -->
     
      <div class="mr-2 mt-5">
          <h3 class="text-wrap text-primary standard-font">{{ product.name }}</h3>
          <h3 class="text-wrap text-info standard-font"> {{ product.tamil_name }}</h3>
      </div>
    
      <div class="mr-3 ml-1 mt-5">
          <h3 class="text-wrap text-primary medium-font">{{ product.content }}</h3>
      </div>
    </div>
    <div class="d-flex justify-space-between">
      <div>
        <h3 class="text-wrap text-info standard-font text-decoration-line-through">Rs.{{ product.rate }}</h3>
        <h3 class="text-wrap text-primary standard-font"> Rs.{{ product.salesprice }}</h3>
      </div>  
      <div class="d-block d-sm-none d-md-none d-lg-none">
            <div>
                  <v-btn size="20" variant="flat" color="primary" icon @click="decrement(product)">
                      <v-icon color="white" size="15">mdi-minus</v-icon>
                  </v-btn>
                  <span class="text-black mobile-qty">
                      <!-- {{ product.qty }} -->
                      <input class="product-mobile-textbox"  v-model="product.qty" @change="productQtyUpdate(product)">
                  </span>
                  <v-btn size="20" variant="flat" color="primary" icon  class="product-mobile-buttonplus" @click="increment(product)">
                      <v-icon color="white" size="15">mdi-plus</v-icon>
                  </v-btn>
            </div>
      </div>
      <div>
        <h3 class="text-wrap text-info standard-font text-center"> Rs.{{ product.totalSalesPrice }}</h3>
      </div>
    </div>
    </div>
    <!--mobile Screen-->
    </v-card>
    
    
                    </div>
                  </div>
            
              </v-list>
            </v-card-text>
    
            <v-card-text>
              <!--alert box-->
              <!-- <v-alert text prominent type="error" v-if="errorResponse">
                <div v-for="(error, i) in cartError.response" :key="i">
                  <h3 v-html="error"></h3> 
                </div>
              </v-alert>-->
              <!--alert box end-->
    
              <!--alert box-->
              <v-alert
                text
                prominent
                type="success"
                v-if="successResponse"
                class="mt-4"
              >
                <div>
                  {{ cartError }}
                  <v-btn
                    outlined
                    @click="refereshPage()"
                    color="primary"
                    class="ml-15"
                    >close</v-btn
                  >
                </div>
              </v-alert>
    
              <v-row
                justify="space-around"
                id="container"
                ref="container"
                v-if="successResponse"
              >
                <v-col cols="12" sm="3" md="3" class="text-center pa-5">
                  <div v-html="footer.address1"></div>
                  <v-divider></v-divider>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="12" sm="3" md="3" class="text-center pa-5">
                  <div v-html="footer.address2"></div>
                  <v-divider></v-divider>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="12" sm="3" md="3" class="text-center pa-5">
                  <div v-html="footer.address3"></div>
                  <v-divider></v-divider>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="12" sm="3" md="3" class="text-center pa-5">
                  <div v-html="footer.address4"></div>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="text-center">
                  <img
                    v-if="footer.qrcode1"
                    alt="QR code"
                    :src="imageUrl + 'public/storage/qrcode/' + footer.qrcode1"
                    height="250"
                    contain
                  />
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="12" sm="3" md="3" class="text-center">
                  <img
                    v-if="footer.qrcode2"
                    alt="QR code"
                    :src="imageUrl + 'public/storage/qrcode/' + footer.qrcode2"
                    height="250"
                    contain
                  />
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="12" sm="3" md="3" class="text-center">
                  <img
                    v-if="footer.qrcode3"
                    alt="QR code"
                    :src="imageUrl + 'public/storage/qrcode/' + footer.qrcode3"
                    height="250"
                    contain
                  />
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="12" sm="3" md="3" class="text-center">
                  <img
                    v-if="footer.qrcode4"
                    alt="QR code"
                    :src="imageUrl + 'public/storage/qrcode/' + footer.qrcode4"
                    height="250"
                    contain
                  />
                </v-col>
              </v-row>
    
              <!--alert box end-->
    
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-form ref="form" class="mt-3" v-if="!successResponse">
                    <!-- <v-row>
                      <v-col cols="12" sm="8" md="8">
                        <v-text-field
                          v-model="mobileno"
                          ref="mobilenoField"
                          label="Mobileno"
                          
                          variant="outlined"
                         :rules="[(v) => !!v || 'Mobileno is required']"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-btn
                          class="ma-2 float-left"
                          outlined
                          color="primary"
                          @click="sendOtp"
                          width="150"
                          height="40"
                        >
                          <span class="black--text">GET OTP</span>
                        </v-btn>
                      </v-col>
    
                      <v-col
                        cols="12"
                        sm="9"
                        md="9"
                        class="mb-1 mt-1"
                        v-if="getOTP "
                      >
                        <h3 class="primary--text mb-5">YOUR OTP : {{ getOTP }}</h3>
                      </v-col>
    
                      <v-col cols="12" sm="6" md="6" class="mb-5">
                        <h3 class="black--text mb-5 text--disabled">
                          ENTER OTP HERE :
                        </h3>
                        <v-otp-input
                          v-model="otp"
                          type="number"
                          :rules="OTPRules"
                          :error="hasError"
                        ></v-otp-input>
                      </v-col>
                    </v-row> -->
                    <v-text-field
                      v-model="name"
                      label="Name"
                      
                      variant="outlined"
                      :rules="[(v) => !!v || 'Name is required']"
                    ></v-text-field>
                    <v-text-field
                          v-model="mobileno"
                          ref="mobilenoField"
                          label="Mobileno"
                          
                          variant="outlined"
                         :rules="[(v) => !!v || 'Mobileno is required']"
                        ></v-text-field>
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      variant="outlined"
                    ></v-text-field>
    
                    <v-text-field
                      v-model="state"
                      label="State"
                      :rules="[(v) => !!v || 'State is required']"
                     variant="outlined"
                    ></v-text-field>
    
                    <v-text-field
                      v-model="deliverycity"
                      label="Delivery City"
                      :rules="[(v) => !!v || 'Delivery City is required']"
                      variant="outlined"
                    ></v-text-field>
    
                    <v-textarea
                      v-model="address"
                      label="Address"
                      :rules="[(v) => !!v || 'Address is required']"
                      variant="outlined"
                    ></v-textarea>
    
                    <v-row justify="space-around" id="container" ref="container">
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="productRate"
                          variant="outlined"
                          label="Rate"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="productOfferPrice"
                          variant="outlined"
                          label="Offer Price"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="productSalesPrice"
                          variant="outlined"
                          label="Sales Price"
                          readonly
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="package_amount"
                   variant="outlined"
                  label="Package Amount"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="total_amount"
                 variant="outlined"
                  label="Total Amount"
                  readonly
                ></v-text-field>
              </v-col>


                    </v-row>
    
                    <v-checkbox
                      v-model="checkbox"
                      label="Order Confirm?"
                      required
                      :rules="[(v) => !!v || 'Please Confirm']"
                    ></v-checkbox>
                    <v-divider></v-divider>
                    <v-btn
                      class="mr-4 mt-5"
                      @click="submitCheckout"
                      variant="outlined"
                      :disabled="chechoutbtn"
                    >
                      submit
                    </v-btn>
                    <v-btn
                      @click="checkoutDialog = false"
                      color="primary"
                      variant="outlined"
                      class="mr-4 mt-5"
                    >
                      close
                    </v-btn>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
    
    
    </template>
    
    <style scoped>
   
    
    .standard-font {
    font-size:14px;
    }
    
    .medium-font{
      font-size:16px;
    }
    
    .product-web-textbox{
        width: 60px;
        background: #c3bebe7d;
        border-radius: 15px;
        text-align: center;
        font-size: 13px;
    }
    .product-mobile-textbox{
        width: 50px;
        background: #c3bebe7d;
        border-radius: 15px;
        text-align: center;
        font-size: 13px;
    }
    
    .product-mobile-buttonplus{
        margin: 0 !important;
    }
    
    .fixed-content {
      width: 100%;
      padding: 16px;
      background-color: #C986BE;
      color: white;
      transition: position 0.3s, top 0.3s;
    }
    
    .fixed-div {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
    }
    
    </style>
    
    <script setup>
    import { ref, onMounted, onBeforeUnmount } from 'vue'
    
    const isFixed = ref(false)
    
    const handleScroll = () => {
      isFixed.value = window.scrollY > 500
    }
    
    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })
    
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll)
    })
    
    
    </script>
    
    <script>
    import { defineComponent } from 'vue';
    
    // Components
    // import HelloWorld from '../components/HelloWorld.vue';
    
    import HeaderBar from '../components/HeaderBar.vue';
    import HeaderMenu from '../components/HeaderMenu.vue';
    import AppLoading from "../components/Loading.vue";
    import FooterSection from '../components/Footer.vue';
    
    import { mapActions, mapGetters } from "vuex";
    
    
    
    import { VUE_WEB_BASEURL } from "../utils/api";
    // import axios from "axios";
    
    export default defineComponent({
      name: 'GiftboxView',
      
      data: () => ({
        imageUrl: "",
        productRate: "0.00",
        productOfferPrice: "0.00",
        productSalesPrice: "0.00",
        package_amount: "0.00",
        total_amount: "0.00",
        cartQty:0,
        imageDialog: false,
        errorDialog: false,
        checkoutDialog: false,
        name: "",
        email: null,
        mobileno: "",
        state: "",
        deliverycity: "",
        address: "",
        checkbox: false,
        chechoutbtn: false,
        hasError:false,
        errorMsg :null,
        emailRules: [
          (v) => !!v || "Email is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        OTPRules: [
          (v) => !!v.length === 6 || "OTP is required",
        ],
        otp: null,
        snackbar: false,
        text: "OTP Sent Successfully",
        timeout: 2000,
      }),
      components: {
        HeaderBar,
        HeaderMenu,
        AppLoading,
        FooterSection,
      },
      computed: {
        ...mapGetters([
          "authStatus",
          "authStatusError",
          "authStatusresponse",
          "getProducts",
          "getBannerDetails",
          "getOrderStatus",
          "orderStatusResponse",
          "getOTP",
          "getFooterDetails",
        ]),
        loading: function () {
          return this.authStatus === "loading";
        },
        products: function () {
          return this.getProducts;
        },
        footer: function () {
          return this.getFooterDetails;
        },
        errorResponse: function () {
          console.log(this.getOrderStatus);
          return this.getOrderStatus === "error";
        },
        successResponse: function () {
          console.log(this.getOrderStatus);
          return this.getOrderStatus === "success";
        },
        cartError: function () {
          return this.orderStatusResponse;
        },
      },
      created() {
        this.imageUrl = VUE_WEB_BASEURL;
        this.fetchGiftboxProducts();
        this.fetchPageDetails("3");
        this.$store.subscribe((mutation) => {
          //console.log(mutation);
          if (mutation.type === "authError") {
            this.errorDialog = true;
          }
    
          if (mutation.type === "authRequest") {
            this.chechoutbtn = true;
          }
    
          if (
            mutation.type === "orderConfirmed" ||
            mutation.type === "orderConfirmedError"
          ) {
            this.chechoutbtn = false;
          }
        });
      },
      methods: {
        ...mapActions([
          "fetchGiftboxProducts",
          "giftboxOrderConfirm",
          "otpAction",
          "fetchPageDetails",
        ]),
        increment(product) {
          // store.commit("authRequest");
          product.qty = parseFloat(product.qty) + 1;
          product.totalRate = product.qty * product.rate;
          product.totalOfferPrice = product.qty * product.offerPrice;
          product.totalSalesPrice = product.qty * product.salesprice;
          this.calculateTotal();
          this.chechoutbtn = false;
        },
        decrement(product) {
          //  store.commit("authRequest");
          product.qty = product.qty === 0 ? 0 : parseFloat(product.qty) - 1;
          product.totalRate = product.qty * product.rate;
          product.totalOfferPrice = product.qty * product.offerPrice;
          product.totalSalesPrice = product.qty * product.salesprice;
          this.calculateTotal();
          this.chechoutbtn = false;
        },
        productDelete(counter) {
          //   console.log(counter);
          this.products.splice(counter, 1);
          this.calculateTotal();
        },
        productQtyUpdate(product) {
          //console.log(product);
          console.log(event.target.value);
          // store.commit("authRequest");
          //check event.target.value is number or not
    
          if (event.target.value) {
            product.qty = product.qty < 0 ? 0 : parseInt(event.target.value);
            product.totalRate = product.qty * product.rate;
            product.totalOfferPrice = product.qty * product.offerPrice;
            product.totalSalesPrice = product.qty * product.salesprice;
            this.calculateTotal();
          } else {
            product.qty = 0;
            product.totalRate = product.qty * product.rate;
            product.totalOfferPrice = product.qty * product.offerPrice;
            product.totalSalesPrice = product.qty * product.salesprice;
            this.calculateTotal();
          }
        },
        calculateTotal() {

            var package_percentage=this.getBannerDetails.package_percentage;
            console.log(package_percentage);

          var totalQtyCalc;
          totalQtyCalc = this.products.reduce(function (categorysum, product) {
            var catTotal = product.products.reduce(function (productsum, product) {
              var qty = parseFloat(product.qty);
              if (!isNaN(qty)) {
                return productsum + qty;
              }
            }, 0);
            if (!isNaN(catTotal)) {
              return categorysum + catTotal;
            }
          }, 0);
          this.cartQty = totalQtyCalc;
          // console.log(totalQtyCalc);
          var totalRateCalc;
          totalRateCalc = this.products.reduce(function (categorysum, product) {
            var catTotal = product.products.reduce(function (productsum, product) {
              var totalRate = parseFloat(product.totalRate);
              if (!isNaN(totalRate)) {
                return productsum + totalRate;
              }
            }, 0);
            if (!isNaN(catTotal)) {
              return categorysum + catTotal;
            }
          }, 0);
    
          //console.log(totalRateCalc);
    
          this.productRate = totalRateCalc.toFixed(2);
    
          var totalOfferPriceCalc;
          totalOfferPriceCalc = this.products.reduce(function (
            categorysum,
            product
          ) {
            var catTotal = product.products.reduce(function (productsum, product) {
              var totalOfferPrice = parseFloat(product.totalOfferPrice);
              if (!isNaN(totalOfferPrice)) {
                return productsum + totalOfferPrice;
              }
            }, 0);
            if (!isNaN(catTotal)) {
              return categorysum + catTotal;
            }
          },
          0);
    
          //console.log(totalOfferPriceCalc);
          this.productOfferPrice = totalOfferPriceCalc.toFixed(2);
    
          var totalSalesPriceCalc;
          totalSalesPriceCalc = this.products.reduce(function (
            categorysum,
            product
          ) {
            var catTotal = product.products.reduce(function (productsum, product) {
              var totalSalesPrice = parseFloat(product.totalSalesPrice);
              if (!isNaN(totalSalesPrice)) {
                return productsum + totalSalesPrice;
              }
            }, 0);
            if (!isNaN(catTotal)) {
              return categorysum + catTotal;
            }
          },
          0);
    
          // console.log(totalSalesPriceCalc);
    
        var packageAmount=(parseFloat(totalSalesPriceCalc)*parseFloat(package_percentage) ) / 100;

        var totalAmount=parseFloat(totalSalesPriceCalc.toFixed(2))+  parseFloat(packageAmount.toFixed(2));

        this.productSalesPrice = totalSalesPriceCalc.toFixed(2);

        this.package_amount  = packageAmount;

        this.total_amount = totalAmount;

        },
        imageDialogOpen(image) {
          console.log(image);
          this.clickedImage = image;
          this.imageDialog = true;
        },
        youtubeOpen(url) {
          console.log(url);
          window.open(url, "_blank");
        },
        popupCheckout() {
          console.log('popup');
          this.checkoutDialog = true;
        },
        async sendOtp() {
          const  valid= this.$refs.mobilenoField.validate();
          console.log(valid);
          if (this.mobileno) {
            // do your submit logic here
            setTimeout(() => {
              const loginData = {
                mobileno: this.mobileno,
              };
    
              this.otpAction(loginData);
    
              this.snackbar = true;
              this.chechoutbtn = false;
              // this.checkoutBtnShow = false;
            }, 500);
          }
        },
    
        async submitCheckout() {
         if(this.otp==null)
         {
          this.hasError = true;
         }
         else
         {
          this.hasError = false;
         }
          
          const { valid } = await this.$refs.form.validate();
          console.log(valid);
          if (valid) {
            this.chechoutbtn = true;
            let orderDetails = [];
            this.products.forEach(function (productlist) {
              productlist.products.forEach(function (product) {
                // console.log(product);
                if (parseFloat(product.qty) > 0) {
                  orderDetails.push(product);
                }
              });
            });
    
            setTimeout(() => {
              this.chechoutbtn = false;
            }, 2000);
            // do your submit logic here
            setTimeout(() => {
              const orderData = {
                name: this.name,
                email: this.email,
                mobileno: this.mobileno,
                otp: this.otp,
                state: this.state,
                deliverycity: this.deliverycity,
                address: this.address,
                productRate: this.productRate,
                productOfferPrice: this.productOfferPrice,
                productSalesPrice: this.productSalesPrice,
                packagePercentage: this.getBannerDetails.package_percentage,
                packageAmount: this.package_amount,
                totalAmount: this.total_amount,
                cartQty: this.cartQty,
                orderDetails: orderDetails,
              };
              //console.log(orderData);
              this.giftboxOrderConfirm(orderData);
    
              //this.chechoutbtn=false;
            }, 500);
          }
        },
        refereshPage() {
          window.location.reload();
        },
        priceListOpen() {
      window.open(VUE_WEB_BASEURL + "giftbox-product/", "_blank");
    },
      }
    });
    </script>
    